import React, { useEffect, useState } from 'react';
import { LocationPermission } from './components/LocationPermission';
import { StoreLocations } from './components/StoreLocations';
import { useGeolocated } from 'react-geolocated';
import { ShopPage } from './ShopPage';
import { ShopStoreBottomSheet } from './components/StoreBottomSheet';
import {
    useRetailersQuery,
    useDutchieStore,
    useCreateCheckoutMutation,
    useSpringBigStore,
    useTheme,
} from '@springbig/shared';
import Loading from '~/shared/Loading';
import { VStack, HStack } from 'native-base';
import { SpIcon } from '~/shared/Icon';
import { faShoppingBag } from '@fortawesome/free-solid-svg-icons';
import { Caption, H3 } from '~/shared/Typography';
import { Section, Button, Modal } from '~/shared/Theme';

export const Shop = () => {

    const { primary } = useTheme();

    const [showOrderSubmittedModal, setShowOrderSubmittedModal] =
        useState(false);
    const [selectedDistance, setSelectedDistance] =
        useState<number>(30);

    const distances = [30, 50, 100];
    const { highlight_text, text } = useTheme();

    const {
        retailer,
        setRetailer,
        setMenuType,
        menuType,
        fullfillmentOption,
        setCheckout,
        showStoreBottomSheet,
        setShowStoreBottomSheet,
        setFullfillmentOption
    } = useDutchieStore();

    const { merchant } = useSpringBigStore();
    const [ isMerchantGeoLocation, setIsMerchantGeoLocation ] = useState(false);

    const {
        mutate: getRetailers,
        data,
        isLoading,
    } = useRetailersQuery();

    const {
        mutate: createCheckout,
        data: newCheckout,
    } = useCreateCheckoutMutation();

    const { isGeolocationAvailable, coords, isGeolocationEnabled } =
        useGeolocated({
            positionOptions: {
                enableHighAccuracy: true,
            },
        });

    useEffect(() => {

        if (isGeolocationEnabled && coords && merchant) {
            const variables = {
                'latitude': coords.latitude,
                'longitude': coords.longitude,
                'maxDistance': selectedDistance,
                'unit': 'MI',
            };
            getRetailers(variables, { onSettled: (data) => {
                if (data?.retailersNearLocation?.length === 0 && merchant.latitude && merchant.longitude) {
                    const variables = {
                        'latitude': parseFloat(merchant.latitude),
                        'longitude': parseFloat(merchant.longitude),
                        'maxDistance': selectedDistance,
                        'unit': 'MI',
                    };
                    setIsMerchantGeoLocation(true);
                    getRetailers(variables);
                }
            } });
        }
    }, [isGeolocationEnabled, coords, getRetailers, selectedDistance, merchant]);

    useEffect(() => {

        if (newCheckout) {
            setCheckout(newCheckout.createCheckout);
        }

        setShowStoreBottomSheet(false);
    }, [newCheckout]);

    useEffect(() => {

        const urlParams = new URLSearchParams(window.location.search);
        const orderNumber = urlParams.get('orderNumber');
        if (orderNumber) {
            setShowOrderSubmittedModal(true);
            createCheckout({
                pricingType: menuType,
                orderType: fullfillmentOption?.key,
                retailerId: retailer?.id,
            });
        }
    }, [window.location.search]);

    const body = () => {

        if (!isGeolocationEnabled || !isGeolocationAvailable) {
            return <LocationPermission />;
        }
        else if (!retailer) {
            return (
                <Section>
                    { isLoading ?
                        <VStack h={'100%'}>
                            <Loading my={'auto'} isLoading={isLoading} />
                        </VStack>
                        :
                        <VStack p={4} h={'100%'} space={4}>
                            <VStack alignItems={'center'} space={4}>
                                <H3 text={'shop.distance'} />
                                <HStack space={4}>
                                    { distances.map((distance, index) =>

                                        <Button
                                            key={index}
                                            modifier={'small'}
                                            text={distance + ' miles'}
                                            variant={'text'}
                                            color={selectedDistance === distance ? highlight_text : text}
                                            onPress={() => setSelectedDistance(distance)}
                                        />
                                    )}
                                </HStack>
                            </VStack>
                            {data && data.retailersNearLocation.length !== 0 ? <StoreLocations
                                setMenuType={setMenuType}
                                setRetailer={setRetailer}
                                stores={isMerchantGeoLocation ?
                                    data?.retailersNearLocation?.sort((a,b) => a?.retailer?.name.localeCompare(b?.retailer?.name)) :
                                    data?.retailersNearLocation
                                }
                                setFullfillmentOption={(value) => setFullfillmentOption(value)}
                                isMerchantGeoLocation={isMerchantGeoLocation}
                            /> : <Caption textAlign={'center'} py={2}>Shopping is Not Avaliable in your current location</Caption>}
                        </VStack>
                    }
                </Section>
            );
        }
        else if (retailer) {
            return <ShopPage />;
        }
    };

    return (
        <>
            { body() }
            <ShopStoreBottomSheet
                isOpen={showStoreBottomSheet}
                onClose={() => setShowStoreBottomSheet(!showStoreBottomSheet)}
            />
            { showOrderSubmittedModal &&
                <Modal
                    isOpen={showOrderSubmittedModal}
                    closeable
                    onClose={() => setShowOrderSubmittedModal(false)}
                >
                    <Modal.Body>
                        <VStack alignItems={'center'} space={4} p={12}>
                            <SpIcon icon={faShoppingBag} color={primary} size={72}/>
                            <Caption
                                text={'shop.order_submitted'}
                                color={primary}
                                fontSize={24}
                            />
                        </VStack>
                    </Modal.Body>
                </Modal>
            }
        </>
    );
};

